<template>
    <div class="">
  {{ status }}
    </div>
  </template>
<script>
export default{
    props:{
        status:String
    }
}
</script>
  